import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles(({ typography }) => {
  const size = typography.pxToRem(13);
  return {
    icon: {
      width: size,
      height: size,
    },
  };
});

const SpotIcon = ({ color }) => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 13 13" className={styles.icon}>
      <circle cx="6.5" cy="6.5" r="6.5" fill={color} />
    </SvgIcon>
  );
};

export default memo(SpotIcon);
